import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import landscape from './modules/landscape'
import premises from './modules/premises/premises'
import topics from './modules/topics'
import superadmin from './modules/superadmin'
import feeds from './modules/feeds'
import subscription from './modules/subscription'
import notifications from './modules/notifications'
import insights from './modules/insights/insights'
import axes from './modules/axes'
import mentions from './modules/mentions'
import temp from './modules/temp.js'
import wordcloud from './modules/wordcloud.js'
import tailwind from '../lib/tailwindConfig'

Vue.use(Vuex)

const state = {
  sectionTitle: 'Landscape Monitor',
  hideScrollbarCount: 0, // Number of Components that needs to hide the scrollbar when they are shown
  isMobile: false,
  isModalDirty: false, // Modal has unsaved changes,
  isDirtyAux: false // Landscape Settings / Insights needs another one
}
const getters = {
  sectionTitle: state => state.sectionTitle,
  hideScrollbar: state => state.hideScrollbarCount !== 0,
  isMobile: state => state.isMobile,
  isModalDirty: state => state.isModalDirty,
  isDirtyAux: state => state.isDirtyAux
}
const mutations = {
  setSectionTitle(state, title) {
    state.sectionTitle = title
  },
  hideScrollbar(state) {
    state.hideScrollbarCount++
  },
  showScrollbar(state) {
    state.hideScrollbarCount--
  },
  setMobile(state, b) {
    state.isMobile = b
  },
  setDirty(state) {
    state.isModalDirty = true
  },
  unsetDirty(state) {
    state.isModalDirty = false
  },
  setDirtyAux(state) {
    state.isDirtyAux = true
  },
  unsetDirtyAux(state) {
    state.isDirtyAux = false
  }
}
const actions = {
  init(context) {
    console.log('Vuex init()')
    function onResize() {
      const desktopMinWidth = tailwind.theme.screens.desktop.slice(0, -2) // Remove 'px'
      const mobile = window.innerWidth < desktopMinWidth
      if (state.isMobile !== mobile) {
        context.commit('setMobile', mobile)
      }
    }
    window.addEventListener('resize', onResize)
    onResize()
  },
  sectionTitle: ({commit}, title) => commit('setSectionTitle', title),
  hideScrollbar: ({commit}) => commit('hideScrollbar'),
  showScrollbar: ({commit}) => commit('showScrollbar'),
  setDirty: ({commit}) => commit('setDirty'),
  unsetDirty: ({commit}) => commit('unsetDirty'),
  setDirtyAux: ({commit}) => commit('setDirtyAux'),
  unsetDirtyAux: ({commit}) => commit('unsetDirtyAux')
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    user,
    landscape,
    premises,
    topics,
    feeds,
    insights,
    axes,
    subscription,
    notifications,
    superadmin,
    mentions,
    temp,
    wordcloud
  },
  strict: process.env.NODE_ENV !== 'production'
})
